import styles from './Footer.module.css';

const Footer = () => {
  return (
    <div className={styles.footer} id="contact">
      <h2 className={styles.title}>Let's Build Something Amazing</h2>
      <p className={styles.description}>
        Ready to bring your ideas to life? I'm always excited to work on new projects and
        challenges.
      </p>
      <div className={styles.contact}>
        <a className={styles.contactInfo} href="mailto:Christoffer@mellem.dev">
          Christoffer@mellem.dev
        </a>

        <a
          className={styles.contactInfo}
          href="https://github.com/nomech"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <a
          className={styles.contactInfo}
          href="https://www.linkedin.com/in/christoffermellem/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
      </div>
    </div>
  );
};

export default Footer;

